import React from 'react'
import { LosseFlexShell } from '@ubo/losse-sjedel'
import type { LosseFlexShellProps, LosseFlexShellType } from '@ubo/losse-sjedel'

// Components
import HistoryDefault from './HistoryDefault'

const TextShell: React.FC<LosseFlexShellProps> = ({ fields, index }) => {
  const types: LosseFlexShellType = {
    default: HistoryDefault
  }

  return <LosseFlexShell types={types} fields={fields} index={index} />
}

export default TextShell
